import { buildContinuousSliderMarkArray } from "./slider.utils.js";
import { SliderLabel } from "./SliderLabel.js";
import slider_module_default from "./slider.module.js";
import { Slider } from "@mantine/core";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/slider/Slider.tsx
const Slider$1 = (props) => {
	const { "data-testid": testId, disabled = false, label, marks = [], max = 100, maxLabel = false, min = 0, minLabel = false, onChange, value } = props;
	const sliderMaxLabel = useMemo(() => /* @__PURE__ */ jsx(SliderLabel, {
		position: "max",
		value: maxLabel
	}), [maxLabel]);
	const sliderMinLabel = useMemo(() => /* @__PURE__ */ jsx(SliderLabel, {
		position: "min",
		value: minLabel
	}), [minLabel]);
	const actualMarks = useMemo(() => buildContinuousSliderMarkArray(marks, max, sliderMaxLabel, min, sliderMinLabel), [
		marks,
		max,
		sliderMaxLabel,
		min,
		sliderMinLabel
	]);
	return /* @__PURE__ */ jsx(Slider, {
		color: "primary",
		"data-testid": testId,
		disabled,
		classNames: slider_module_default,
		label,
		marks: actualMarks,
		max,
		min,
		onChange,
		value
	});
};

//#endregion
export { Slider$1 as Slider };